function isUndefinedOrNull(value: any) {
    return value === null || value === undefined
}

function isArguments(object: any) {
    return Object.prototype.toString.call(object) == '[object Arguments]'
}

function isNumberNaN(value: any) {
    // NaN === NaN -> false
    return typeof value == 'number' && value !== value
}

function areZerosEqual(zeroA: number, zeroB: number) {
    // (1 / +0|0) -> Infinity, but (1 / -0) -> -Infinity and (Infinity !== -Infinity)
    return 1 / zeroA === 1 / zeroB
}

function objEquiv(a: any, b: any): boolean {
    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false

    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if (isArguments(a)) {
        if (!isArguments(b)) {
            return false
        }
        a = Array.prototype.slice.call(a)
        b = Array.prototype.slice.call(b)
        return isEqual(a, b)
    }
    try {
        const ka = Object.keys(a)
        const kb = Object.keys(b)
        let key: any
        let i: number

        // having the same number of owned properties (keys incorporates
        // hasOwnProperty)
        if (ka.length != kb.length) return false
        //the same set of keys (although not necessarily the same order),
        ka.sort()
        kb.sort()
        //~~~cheap key test
        for (i = ka.length - 1; i >= 0; i--) {
            if (ka[i] != kb[i]) return false
        }
        //equivalent values for every corresponding key, and
        //~~~possibly expensive deep test
        for (i = ka.length - 1; i >= 0; i--) {
            key = ka[i]
            if (!isEqual(a[key], b[key])) return false
        }
        return true
    } catch (e) {
        //happens when one is a string literal and the other isn't
        return false
    }
}

export function isEqual(actual: any, expected: any) {
    // enforce Object.is +0 !== -0
    if (actual === 0 && expected === 0) {
        return areZerosEqual(actual, expected)

        // 7.1. All identical values are equivalent, as determined by ===.
    } else if (actual === expected) {
        return true
    } else if (actual instanceof Date && expected instanceof Date) {
        return actual.getTime() === expected.getTime()
    } else if (isNumberNaN(actual)) {
        return isNumberNaN(expected)

        // 7.3. Other pairs that do not both pass typeof value == 'object',
        // equivalence is determined by ==.
    } else if (typeof actual != 'object' && typeof expected != 'object') {
        return actual == expected

        // 7.4. For all other Object pairs, including Array objects, equivalence is
        // determined by having the same number of owned properties (as verified
        // with Object.prototype.hasOwnProperty.call), the same set of keys
        // (although not necessarily the same order), equivalent values for every
        // corresponding key, and an identical 'prototype' property. Note: this
        // accounts for both named and indexed properties on Arrays.
    } else {
        return objEquiv(actual, expected)
    }
}
